export default __webpack_public_path__ + "static/media/Behaviour Chart.24f9bca9.pdf";